var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('canvasjs',_vm._b({attrs:{"chartOptions":_vm.chartOptions}},'canvasjs',_vm.$props,false))}
var staticRenderFns = []

export { render, staticRenderFns }